class UserHeaderCtrl {
  $onInit() {
    this.group = {
      type: 'employee',
      name: 'employee',
    };
  }
}

export default {
  controller: UserHeaderCtrl,
  controllerAs: 'ctrl',
  template:
    '<edit-group-header group="ctrl.group" previous-state="ctrl.previousState" list-sref="dashboard.manage.users.list" title="{{ctrl.title}}"></edit-group-header>',
  bindings: {
    previousState: '<',
    title: '@?',
  },
};
